<template>
    <div>
       <my-form 
        label-width="0" 
        v-model="form" 
        @submit="submit()">

            <el-form-item 
            :rules="newRule('手机号', 'required','mobile')" 
            prop="mobile">
                <el-input 
                    v-model="form.mobile" 
                    clearable 
                    autocomplete="off" 
                    placeholder="请输入手机号">
                </el-input>
            </el-form-item>

            <el-form-item 
                :rules="newRule('验证码', 'required')" 
                class="yzmInput"
                prop="captcha">

                <el-input 
                    v-model="form.captcha" 
                    clearable 
                    autocomplete="off" 
                    placeholder="请输入验证码">
                </el-input>

                <img 
                    class="position"
                    id="captcha" 
                    style="cursor: pointer; cursor: hand; float:right; width: 120px; height:35px;"
                    onclick="this.src='/hzbtenderagentzero/admin/captcha.html?'+Math.random();" 
                    src="/hzbtenderagentzero/admin/captcha.html"
                >
            </el-form-item>

            <el-form-item 
                :rules="newRule('手机验证码', 'required')" 
                class="yzmInput"
                prop="phonecode">

                <el-input 
                    v-model="form.phonecode" 
                    clearable 
                    autocomplete="off" 
                    placeholder="请输入手机验证码">
                </el-input>
                <el-button 
                    class="position" 
                    type="primary" 
                    :disabled="isDisable"
                    @click="getNoteCode()" 
                    :loading="yzm_loading_controller">
                        {{yzmText}}
                </el-button>
            </el-form-item>

            <template 
            slot="btn" 
            slot-scope="scope">
                <el-button 
                    @click="scope.submitHandler" 
                    @keyup.enter.native="loginEnter()" 
                    type="primary" 
                    style="width:100%;height:45px;font-size:16px">
                        登&nbsp;&nbsp;录
                </el-button>
                <p style="text-align:center;">
                    若您尚未注册，请点击
                    <a :href="zhuce" target="_blank" style="color:#008eff">注册</a>
                </p>
            </template>
        </my-form> 
    </div>
</template>

<script>
export default {
    props: {
        roleCode: {
            type: String,
            default: ''
        },
    },
    data: () => ({
        // 登录参数
        form:{
            mobile:'',
            captcha:'',
            phonecode:'',
        },
        captchaurl:'',

        zhuce:window._config.zhuce,

        //控制验证码的字段
        yzm_loading_controller: false,
        isDisable: false,
        yzmText:'获取手机验证码',
    }),
    methods: {
        getNoteCode(){
            var that = this;
            if(!this.form.captcha){
                ShowMsg('请输入图形验证码','error')
            }else if(!this.form.mobile){
                ShowMsg('请输入手机号','error')
            }else{
                $.post(`${that.$store.getters.ageUrl}/api/auth/third/mobile/verifyKey`, {
                    mobile: that.form.mobile,
                    captcha: that.form.captcha,
                }, function (data, res) {
                    if(data.result){
                        //倒计时
                        that.yzm_loading_controller = true;
                        that.isDisable = true
                        that.yzmText = '手机验证码已发送'
                        //倒计时
                        var remain = 60;
                        var int = setInterval(function () {
                            if (remain != 0) {
                                remain--
        
                            } else {
                                clearInterval(int);
                
                                that.isDisable = false;
                                that.yzm_loading_controller = false;
                                that.yzmText = '获取手机验证码'
                            }
                        }, 1000)
                    }else{
                        ShowMsg(data.msg,'error')
                    }
                    
                })
            }
        },
        // 登录
        submit(){
            var that = this;
            $.get(`${that.$store.getters.ageUrl}/api/auth/third/mobile/account`,{
                mobile:that.form.mobile,
                verifyKey:that.form.phonecode,
                userType:that.roleCode,
            }, function (data, res) {
                if(data.result){
                    if(data.code == '200'){
                        // 调用store.js的login方法
                        that.$store.dispatch('views/login',{obj:data.tdata});
                    }else{
                        var obj = { mobile:that.form.mobile,verifyKey:that.form.phonecode };
                        that.$emit('bindClick',obj)
                    }
                }else{
                    if(data.code == 'jump-url'){
                        window.location.href = data.tdata.url;
                        return;
                    }else{
                        if(data.msg){
                            ShowMsg(data.msg,'error');
                        }else{
                            ShowMsg(data.errors.captcha || data.errors.password,'error');
                        }
                        
                    }
                }
                
            })
        }
    },
    mounted() {
        var that = this
    },
}
</script>

<style scoped lang="scss">
    .yzmInput{ position: relative; }
    .yzmInput .position{ position: absolute; z-index: 100; top: 4px; right:5px }
</style>